// passwordUtils.js

export const validatePasswordsMatch = (password, confirmPassword) => {
    if (password !== confirmPassword) {
      return 'Las nuevas contraseñas no son iguales';
    }
    return '';
  };
  
  export const validatePasswordComplexity = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  
    if (password.length < minLength) {
        return 'La contraseña debe tener al menos 8 caracteres';
    }
    
    if (!hasUpperCase) {
    return 'La contraseña debe contener al menos una letra mayúscula';
    }
    
    if (!hasLowerCase) {
    return 'La contraseña debe contener al menos una letra minúscula';
    }
    
    if (!hasNumbers) {
    return 'La contraseña debe contener al menos un número';
    }
      
  
    // if (!hasSpecialChars) {
    //   return 'Password must contain at least one special character';
    // }
  
    return '';
  };
  